/**
 * In the MyRave app, once somebody is signed in: anything paid in the App
 * Store or Google Play but never verified by the API (the app closed between
 * paying and the answer) is sent now (the user, 2026-10-07, evening: a store
 * purchase must never be lost). Quiet — no store sheet. Renders nothing; in a
 * browser it does nothing.
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { buysInStore, restoreInStore } from '@/lib/store';
import { useAuth } from './AuthProvider';

let done: string | null = null;

export function StoreSync() {
  const { user, offline } = useAuth();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!user || offline || !buysInStore() || done === user.id) return;
    done = user.id;
    void restoreInStore(true)
      .then((entitlements) => { if (entitlements) queryClient.setQueryData(['me', 'entitlements'], entitlements); })
      .catch(() => { done = null; });
  }, [user, offline, queryClient]);
  return null;
}
